<template>
    <div
        id="be-settings"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />

            <main class="mx-auto">
                <b-container
                    fluid
                    class="mt-5"
                >
                    <h2 class="text-uppercase mb-0">{{ $t("Impostazioni consegna e pagamento") }}</h2>
                    <b-form
                        @submit.prevent="onSubmit"
                        v-show="loaded"
                        class="mt-3"
                    >
                        <settings-delivery-and-payments-section
                            ref="settingsDeliveryAndPaymentsSection"
                            :settings="settings"
                        />

                        <b-form-row class="mt-5">
                            <b-button
                                type="submit"
                                variant="primary"
                                :disabled="!isValid || saving"
                                class="col-sm-12 col-md-4 offset-md-4 btn-rikorda1"
                            >
                                {{ saving ? $t("Salvataggio") : $t("Salva") }}
                            </b-button>
                        </b-form-row>
                    </b-form>
                </b-container>
            </main>

            <backend-footer />

        </div>
    </div>
</template>

<script>
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import SettingsDeliveryAndPaymentsSection from "../../components/backend/SettingsDeliveryAndPaymentsSection";

export default {
    name: "BackendSettings",

    components: {
        BackendHeader,
        BackendFooter,
        SettingsDeliveryAndPaymentsSection
    },

    data() {
        return {
            loaded: false,
            settings: {},
            saving: false
        };
    },

    computed: {
        isValid() {
            return (
                this.loaded &&
                this.$refs.settingsDeliveryAndPaymentsSection.isValid
            );
        }
    },

    mounted() {
        if (this.$store.getters.isAgent) {
            this.$router.push({
                name: "backend-dashboard"
            });
        } else {
            this.loadSettings();
        }
    },

    methods: {
        loadSettings() {
            this.$api.backendGetSettings().then((response) => {
                console.log(
                    "BACKEND_GET_SETTINGS",
                    response,
                    response.settings.flagFattura
                );
                if (response.settings) {
                    this.settings = response.settings;

                    this.$nextTick(function () {
                        this.loaded = true;
                        this.$refs.settingsDeliveryAndPaymentsSection.loaded = true;
                    });
                }
            });
        },

        onSubmit() {
            if (this.isValid) {
                this.saving = true;
                return this.$api.backendSaveSettings(this.settings).then(() => {
                    this.saving = false;
                });
            }
        }
    }
};
</script>

<style></style>
